<template>
  <div class="landing-spacer" :style="{ height: `${height || 80}px` }"></div>
</template>

<script setup>
defineProps({ height: { type: Number, default: 80 } })
</script>
